import { render } from "./BibleEmbeddedView.vue?vue&type=template&id=1335fb03&scoped=true"
import script from "./BibleEmbeddedView.vue?vue&type=script&lang=js"
export * from "./BibleEmbeddedView.vue?vue&type=script&lang=js"

import "./BibleEmbeddedView.vue?vue&type=style&index=0&id=1335fb03&scoped=true&lang=css"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1335fb03"]])

export default __exports__